import React from "react";
import { Card, Button, Badge, ProgressBar } from "react-bootstrap";
import { FaUsers, FaChalkboardTeacher, FaEdit, FaTrash } from "react-icons/fa";
import localization from "services/localization";
import { getDepartmentTypes } from "services/constants";

export function DepartmentCard({ department, onEdit, onDelete, users }) {
  const DEPARTMENT_TYPE_OPTIONS = getDepartmentTypes();

  const studentCount = department.members?.length || 0;
  const capacity = department.capacity || 30;
  const departmentType = department.type || "classroom";
  const typeLabel = DEPARTMENT_TYPE_OPTIONS.find(
    (t) => t.value === departmentType,
  )?.label;

  const teacherName = department.user_id
    ? users.find((u) => u.id === department.user_id)?.name
    : "Unknown Teacher";

  const DEPARTMENT_TYPE_STYLES = {
    classroom: "bg-blue-100 text-blue-700 border-blue-300",
    hr: "bg-green-100 text-green-700 border-green-300",
    administrative: "bg-purple-100 text-purple-700 border-purple-300",
  };
  return (
    <Card className="common-card shadow-md hover:shadow-2xl transition-all cursor-pointer border rounded-2xl backdrop-blur p-3 mb-4">
      <Card.Body className="flex flex-col justify-between h-full">
        <div className="flex items-center gap-2 mb-4">
          {/* Title */}
          <div className="min-w-0 flex-1">
            <h5 className="text-lg font-bold truncate" title={department.name}>
              {department.name}
            </h5>
          </div>

          {/* Badge */}
          <span
            className={`
      flex-shrink-0
      text-xs capitalize border px-2 py-0.5 rounded-full whitespace-nowrap
      ${
        DEPARTMENT_TYPE_STYLES[departmentType] ||
        DEPARTMENT_TYPE_STYLES.classroom
      }
    `}
          >
            {typeLabel}
          </span>
        </div>

        {/* Teacher Info */}
        <div className="flex justify-between items-center mt-3 mb-4 px-2">
          <div className="flex items-center gap-2">
            <FaChalkboardTeacher className="sub-icon" />
            <span className="text-sm font-medium">{teacherName}</span>
          </div>

          <div className="flex items-center gap-2 info-badge">
            <FaUsers className="info-badge" />
            <span className="text-sm font-semibold">
              {studentCount} {localization.members || "members"}
            </span>
          </div>
        </div>

        {/* Occupancy Info */}
        {/* <div className="mb-4 text-left">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2 text-gray-600">
                            <FaUsers className="text-gray-600" />
                            <span className="text-sm">Occupancy</span>
                        </div>
                        <span className="text-sm font-semibold text-gray-800">
                            {studentCount}/{capacity}
                        </span>
                    </div> */}

        {/* Custom Progress Bar */}
        {/* <div className="w-full h-2 bg-gray-300 rounded-full overflow-hidden">
                        <div
                            className={`h-full ${getProgressColor()} transition-all duration-300`}
                            style={{ width: `${occupancyPercentage}%` }}
                        ></div>
                    </div>
                </div> */}

        {/* <div className="flex justify-around text-center my-4">
                    <div className="flex flex-col items-center">
                        <FaUsers className="text-blue-500 mb-1" size={20} />
                        <span className="text-lg font-bold text-gray-900">
                            {studentCount}
                        </span>
                        <span className="text-sm text-gray-500">Students</span>
                    </div>
                </div> */}

        {/* Buttons */}
        <div className="flex gap-2 mt-auto">
          <Button
            size="sm"
            className="action-btn-outline primary flex-1 d-flex align-items-center justify-center gap-2 border transition-all rounded-pill"
            onClick={() => onEdit(department)}
          >
            <FaEdit className="h-4 w-4" />
            {localization.edit || "Edit"}
          </Button>

          <Button
            variant="outline-danger"
            size="sm"
            className="action-btn-outline danger flex-1 d-flex align-items-center justify-center gap-2 border transition-all rounded-pill"
            onClick={() => onDelete(department)}
          >
            <FaTrash className="h-4 w-4" />
            {localization.delete || "Delete"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
